import { render, staticRenderFns } from "./AppProductViewer.vue?vue&type=template&id=09dad195&scoped=true"
import script from "./AppProductViewer.vue?vue&type=script&lang=ts"
export * from "./AppProductViewer.vue?vue&type=script&lang=ts"
import style0 from "./AppProductViewer.vue?vue&type=style&index=0&id=09dad195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dad195",
  null
  
)

export default component.exports